import { handleActions } from "redux-actions";

import {
	getFiltersDatesListAsyncAction,
	getFiltersDateAsyncAction,
	postFiltersDateAsyncAction,
	updateFiltersDateAsyncAction,
	deleteFiltersDateAsyncAction,
	resetAction,
} from "./leaderboardActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	filters_dates_list: defaultAjaxState,
	filters_date_detail: defaultAjaxState,
	post_filters_date: defaultAjaxState,
	update_filters_date: defaultAjaxState,
	delete_filters_date: defaultAjaxState,
};

export const leaderboardReducer = handleActions(
	new Map([
		// get leaderboard date filters list
		[
			getFiltersDatesListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				filters_dates_list: {
					...initialState.filters_dates_list,
					loading: true,
				},
			}),
		],
		[
			getFiltersDatesListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				filters_dates_list: {
					...initialState.filters_dates_list,
					response: payload,
				},
			}),
		],
		[
			getFiltersDatesListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				filters_dates_list: {
					...initialState.filters_dates_list,
					error: payload,
				},
			}),
		],

		// get leaderboard date filter detail
		[
			getFiltersDateAsyncAction.request,
			(state, { payload }) => ({
				...state,
				filters_date_detail: {
					...initialState.filters_date_detail,
					loading: true,
				},
			}),
		],
		[
			getFiltersDateAsyncAction.success,
			(state, { payload }) => ({
				...state,
				filters_date_detail: {
					...initialState.filters_date_detail,
					response: payload,
				},
			}),
		],
		[
			getFiltersDateAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				filters_date_detail: {
					...initialState.filters_date_detail,
					error: payload,
				},
			}),
		],

		// post leaderboard date filter
		[
			postFiltersDateAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_filters_date: {
					...initialState.post_filters_date,
					loading: true,
				},
			}),
		],
		[
			postFiltersDateAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_filters_date: {
					...initialState.post_filters_date,
					response: payload,
				},
			}),
		],
		[
			postFiltersDateAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_filters_date: {
					...initialState.post_filters_date,
					error: payload,
				},
			}),
		],

		// update leaderboard date filter
		[
			updateFiltersDateAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_filters_date: {
					...initialState.update_filters_date,
					loading: true,
				},
			}),
		],
		[
			updateFiltersDateAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_filters_date: {
					...initialState.update_filters_date,
					response: payload,
				},
			}),
		],
		[
			updateFiltersDateAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_filters_date: {
					...initialState.update_filters_date,
					error: payload,
				},
			}),
		],

		// delete leaderboard date filter
		[
			deleteFiltersDateAsyncAction.request,
			(state, { payload }) => ({
				...state,
				delete_filters_date: {
					...initialState.delete_filters_date,
					loading: true,
				},
			}),
		],
		[
			deleteFiltersDateAsyncAction.success,
			(state, { payload }) => ({
				...state,
				delete_filters_date: {
					...initialState.delete_filters_date,
					response: payload,
				},
			}),
		],
		[
			deleteFiltersDateAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				delete_filters_date: {
					...initialState.delete_filters_date,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
